import React, { Component } from 'react';
import ReadAxios from "../axiosComponent/read";
import isEmpty from "lodash/isEmpty";
import { translate } from "react-i18next";

export class LoadTyperender extends Component {
  constructor(props) {
    super(props);

    this.state = {
      routeDetail: [],
    };
  }

  async componentDidMount() {
    // let dataArray =
    //   (await ReadAxios({
    //     completeURL: `${process.env.REACT_APP_TA_API_URL}/orders/masters/load/type/${this.props.loadid}`,
    //   })) || [];
    //   console.log(dataArray);
    // dataArray = isEmpty(dataArray) ? [] : dataArray.data.resultSet;
    // this.setState({ routeDetail: dataArray || [] });
  }
  render() {
    const { t } = this.props;
    const { routeDetail } = this.state;
    return (
      <>
        <div>
          <span
            className="sumo_truck_quantity"
            style={{
              width: "55px",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
          >
          </span>
          {this.props.loadid == 2 ? (
            <img src="assets/svg/sumo_truck_green.svg" alt="sumo_truck" width="65%" height="40%" />
          ) : (
            <>
              {this.props.loadid == 3 ? (
                <img src="assets/svg/sumo_truck_brown.svg" alt="sumo_truck" width="65%" height="40%" />
              ) : (
                <>
                  {this.props.loadid == 4 ? (
                    <img src="assets/svg/sumo_truck_yellow.svg" alt="sumo_truck" width="65%" height="40%" />
                  ) : (
                    <>
                      {this.props.loadid == 1 ? (
                        <img src="assets/svg/sumo_truck_navy_blue.svg" alt="sumo_truck" width="65%" height="40%" />
                      ) : (
                        null
                      )}</>
                  )}</>
              )}
            </>
          )}
          {/* <img src="assets/svg/sumo_truck.svg" alt="sumo_truck" width="60%" /> */}
        </div>
        <label className="order-load-type">
          <span style={{ fontColor: "grey" }}>{t("list_view.load_type") || "Load Type"} : </span>&nbsp;
          <span className="order-load-type-bold">{this.props.loadid == 2 ? (
            "Chilled"
          ) : (
            <>
              {this.props.loadid == 3 ? (
                "Ambient"
              ) : (
                <>
                  {this.props.loadid == 4 ? (
                    "Dry"
                  ) : (
                    <>
                      {this.props.loadid == 1 ? (
                        <>
                          {localStorage.getItem('customerNumber') == "549" ?
                            "Reefer"
                            :
                            "Frozen"
                          }
                        </>

                      ) : (
                        null
                      )}</>
                  )}</>
              )}
            </>
          )}</span>
        </label>
      </>
      // <div>
      //     <span>{this.props.loadid ? routeDetail[0].checkPointName : "NA"}</span> 
      //     <span>{this.props.loadid}</span
      // </div>
    )
  }
}

export default translate("shipment")(LoadTyperender)
